import { Component, OnInit, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { LocalizationService } from '../../core/localization/localization.service';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { AinStateComponent } from '../../shared/design-system/state.component';
import { CatalogService, ServiceOrder } from './catalog.service';

@Component({
  standalone: true,
  selector: 'ain-service-orders',
  imports: [AinPageComponent, AinStateComponent, RouterLink, TableModule, ButtonModule],
  template: `
    <ain-page [title]="t('catalog.service.orders.title')" [description]="t('catalog.service.orders.description')">
      @if (loading()) {
        <ain-state type="loading" [title]="t('catalog.loading')" />
      } @else {
        <section class="panel">
          <div class="toolbar">
            <button pButton type="button" [label]="t('catalog.action.create')" (click)="openCreate()"></button>
            <button pButton type="button" [label]="t('catalog.action.refresh')" severity="secondary" (click)="load()"></button>
          </div>
          <p-table [value]="rows()" [paginator]="true" [rows]="15">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ t('catalog.service.orderNumber') }}</th>
                <th>{{ t('catalog.service.title') }}</th>
                <th>{{ t('catalog.tracking.status') }}</th>
                <th>{{ t('catalog.service.priority') }}</th>
                <th>{{ t('catalog.service.customerReference') }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td><button type="button" class="link-btn" (click)="openDetail(row.id)">{{ row.orderNumber }}</button></td>
                <td>{{ row.title }}</td>
                <td>{{ row.status }}</td>
                <td>{{ row.priority }}</td>
                <td>{{ row.customerReferenceNumber || '-' }}</td>
              </tr>
            </ng-template>
          </p-table>
        </section>
      }
    </ain-page>
  `,
  styles: [`
    .panel { display: grid; gap: 10px; }
    .toolbar { display: flex; gap: 8px; }
    .link-btn { border: 0; background: none; color: #1d4ed8; cursor: pointer; font-weight: 600; padding: 0; }
  `]
})
export class ServiceOrdersComponent implements OnInit {
  private readonly service = inject(CatalogService);
  private readonly router = inject(Router);
  private readonly localization = inject(LocalizationService);

  readonly loading = signal(true);
  readonly rows = signal<ServiceOrder[]>([]);

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading.set(true);
    this.service.listServiceOrders().subscribe({
      next: rows => {
        this.rows.set(rows);
        this.loading.set(false);
      },
      error: () => {
        this.rows.set([]);
        this.loading.set(false);
      }
    });
  }

  openDetail(id: string): void {
    void this.router.navigate(['/services/orders', id]);
  }

  openCreate(): void {
    void this.router.navigate(['/services/orders', 'new']);
  }

  t(key: string): string {
    return this.localization.translate(key);
  }
}
